module.exports = __webpack_public_path__ + "img/sayings@2x.0c1b5ff.jpg";